import ImpactHeader from "../components/header/ImpactHeader";
import SideBar from "../components/sidebar/Sidebar";
import RegisteredBusiness from "../components/table/RegisteredBusiness";


export default function RegisteredBusiLayout ({ rows }) {

    return (
        <div>
            <SideBar />
            <ImpactHeader />
            <div className="impact-main-app-content">
                <RegisteredBusiness />
            </div>
        </div>

    )
}